import { render, staticRenderFns } from "./BonusPaymentTypeView.vue?vue&type=template&id=e5ac68f0&"
import script from "./BonusPaymentTypeView.vue?vue&type=script&lang=js&"
export * from "./BonusPaymentTypeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports